import { Ng2StateDeclaration } from '@uirouter/angular';
import { ClusterEditComponent } from '@fi-app/cluster/cluster-edit/cluster-edit.component';
import { FiClusterStateResolveCluster } from './resolve/cluster';
import { FiClusterStateResolvePageTitle } from './resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiClusterEditState: Ng2StateDeclaration = {
    name: FiStateNames.Cluster.Edit,
    url: '/:Id/Edit',
    views: {
        '@': {
            component: ClusterEditComponent,
        },
    },
    resolve: {
        cluster: FiClusterStateResolveCluster,
        pageTitle: FiClusterStateResolvePageTitle,
    },
};
